export const getLargestElHeight = (selector: string) => (
  Array.from(document.querySelectorAll<HTMLDivElement>(selector))
  .reduce((max, el) => (el.scrollHeight > max ? el.scrollHeight : max), 0)
)
